// customAlphabet must be loaded from the main entry because nanoid v3+ blocks subpath imports.
const { customAlphabet } = require('nanoid')

const generateId = customAlphabet('0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ', 12)

function generateShipmentNumber () {
  return generateId()
}

module.exports = generateShipmentNumber
